import React, { Component } from "react";
import { Segment, Statistic, Divider, Header } from "semantic-ui-react";
import Constants from "utilities/Constants";
import Strings from "utilities/StringSelector";

class DevicesStatistics extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      statistics: [],
      // Controller para cancelar requests caso saia da tela
      controller: new AbortController()
    };
  }

  retrieveData = () => {
    fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "deviceStatistics", { mode: "cors", signal: this.state.controller.signal })
      .then(res => res.json())
      .then(data => this.setState({ statistics: data.deviceStatistics, }))
      .catch((e) => {
        console.log("DeviceStatistics request interrupted: ", e);
      });
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.retrieveData();
    // store intervalId in the state so it can be accessed later
    this.setState({ intervalID: setInterval(this.retrieveData, 5000) });
  }

  componentWillUnmount() {
    this.state.controller.abort();
    clearInterval(this.state.intervalID);
  }

  render() {
    return (
      <Segment style={segmentStyle}>

        <Header as='h3' textAlign="center" color="teal">
          {Strings.NUM_OF_DEVICES}
        </Header>
        <Divider style={{ marginTop: "-8px" }} />

        <Statistic.Group widths="4" size="small">
          <Statistic size="large">
            <Statistic.Value>{this.state.statistics.masters}</Statistic.Value>
            <Statistic.Label>{Strings.MASTERS}</Statistic.Label>
          </Statistic>

          <Statistic size="large">
            <Statistic.Value>{this.state.statistics.slaves}</Statistic.Value>
            <Statistic.Label>{Strings.SLAVES}</Statistic.Label>
          </Statistic>

          <Statistic size="large">
            <Statistic.Value>{this.state.statistics.online}</Statistic.Value>
            <Statistic.Label>{Strings.ONLINE_STRING}</Statistic.Label>
          </Statistic>

          <Statistic size="large">
            <Statistic.Value>{this.state.statistics.missing}</Statistic.Value>
            <Statistic.Label>{Strings.MISSING_PLURAL_STRING}</Statistic.Label>
          </Statistic>

        </Statistic.Group>
      </Segment>
    );
  }
}

const segmentStyle = {
  textAlign: "center",
  marginBottom: "4vh"
};

export default DevicesStatistics;